import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import defaultIndex from '@/views/defaultIndex'
import SelectCity from '@/views/selectCity'
import takeOutShopList from '@/views/takeOutShopList.vue'
import takeOutShopDetail from '@/views/takeOutShopDetail.vue'
import mShop from '@/views/mShop.vue'
// import mealQueryIndex from '@/views/mealQueryIndex.vue'
import takeoutQueryIndex from '@/views/takeoutQueryIndex.vue'
import commonQueryIndex from '@/views/commonQueryIndex.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/defaultIndex',
      name: 'defaultIndex',
      component: defaultIndex
    },    
    {
      path: '/selectCity',
      name: 'SelectCity',
      component: SelectCity
    },
    {
      path: '/takeOutShopList',
      name: 'takeOutShopList',
      component: takeOutShopList
    },
    {
      path: '/takeOutShopDetail',
      name: 'takeOutShopDetail',
      component: takeOutShopDetail
    },
    {
      path: '/mShop',
      name: 'mShop',
      component: mShop
    },
    // {
    //   path: '/mealQueryIndex',
    //   name: 'mealQueryIndex',
    //   component: mealQueryIndex
    // },
    {
      path: '/takeoutQueryIndex',
      name: 'takeoutQueryIndex',
      component: takeoutQueryIndex
    },
    {
      path: '/commonQueryIndex',
      name: 'commonQueryIndex',
      component: commonQueryIndex
    }                              
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js